import React, { useState } from 'react';
import { FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';
import { postRandevu } from '../services/api';
import './Randevu.css';

const Randevu = () => {
  const [form, setForm] = useState({
    ad_soyad: '',
    telefon: '',
    email: '',
    arac_bilgisi: '',
    hizmet_turu: '',
    tarih: '',
    saat: '',
    notlar: '',
  });
  const [gonderildi, setGonderildi] = useState(false);
  const [hata, setHata] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    try {
      await postRandevu(form);
      setGonderildi(true);
      setForm({
        ad_soyad: '', telefon: '', email: '', arac_bilgisi: '',
        hizmet_turu: '', tarih: '', saat: '', notlar: '',
      });
    } catch (err) {
      setHata('Randevu oluşturulamadı. Lütfen tekrar deneyin.');
    }
  };

  const hizmetTurleri = [
    'Motor Bakım & Onarım',
    'Fren Sistemi',
    'Yağ Değişimi',
    'Lastik & Balans',
    'Elektrik & Elektronik',
    'Klima Bakımı',
    'Periyodik Bakım',
    'Diğer',
  ];

  return (
    <div className="randevu-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>Online Randevu</h1>
          <p>Hızlı ve kolay randevu oluşturun</p>
        </div>
      </section>

      <section className="randevu-content">
        <div className="container">
          <div className="randevu-wrapper">
            <div className="randevu-info">
              <FaCalendarAlt className="randevu-big-icon" />
              <h2>Randevu Al</h2>
              <p>
                Formu doldurarak online randevu oluşturabilirsiniz. 
                Randevunuz onaylandığında size bilgi verilecektir.
              </p>
              <ul className="randevu-benefits">
                <li><FaCheckCircle /> Hızlı randevu oluşturma</li>
                <li><FaCheckCircle /> Sıra beklemeden hizmet</li>
                <li><FaCheckCircle /> SMS ile randevu hatırlatma</li>
                <li><FaCheckCircle /> Ücretsiz araç kontrol</li>
              </ul>
            </div>

            <div className="randevu-form-wrapper">
              {gonderildi ? (
                <div className="success-message">
                  <FaCheckCircle />
                  <h3>Randevunuz Oluşturuldu!</h3>
                  <p>En kısa sürede onay için sizinle iletişime geçeceğiz.</p>
                  <button onClick={() => setGonderildi(false)} className="btn btn-primary">
                    Yeni Randevu Al
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="randevu-form">
                  {hata && <div className="error-message">{hata}</div>}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Ad Soyad *</label>
                      <input
                        type="text"
                        name="ad_soyad"
                        value={form.ad_soyad}
                        onChange={handleChange}
                        required
                        placeholder="Adınız ve soyadınız"
                      />
                    </div>
                    <div className="form-group">
                      <label>Telefon *</label>
                      <input
                        type="tel"
                        name="telefon"
                        value={form.telefon}
                        onChange={handleChange}
                        required
                        placeholder="05XX XXX XX XX"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>E-posta</label>
                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="ornek@email.com"
                      />
                    </div>
                    <div className="form-group">
                      <label>Araç Bilgisi *</label>
                      <input
                        type="text"
                        name="arac_bilgisi"
                        value={form.arac_bilgisi}
                        onChange={handleChange}
                        required
                        placeholder="Marka, model, yıl"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Hizmet Türü *</label>
                    <select
                      name="hizmet_turu"
                      value={form.hizmet_turu}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Hizmet seçin...</option>
                      {hizmetTurleri.map(h => (
                        <option key={h} value={h}>{h}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Tarih *</label>
                      <input
                        type="date"
                        name="tarih"
                        value={form.tarih}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Saat *</label>
                      <select
                        name="saat"
                        value={form.saat}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Saat seçin...</option>
                        {['08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
                          '11:00', '11:30', '13:00', '13:30', '14:00', '14:30',
                          '15:00', '15:30', '16:00', '16:30', '17:00'].map(s => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Notlar</label>
                    <textarea
                      name="notlar"
                      value={form.notlar}
                      onChange={handleChange}
                      rows="3"
                      placeholder="Ek bilgi veya notlarınız..."
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary btn-full">
                    Randevu Oluştur
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Randevu;
